// extracted by mini-css-extract-plugin
export var resizer = "_gd-0";